import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import WhoAreWe from './pages/about/WhoAreWe';
import WhyItMatters from './pages/about/WhyItMatters';
import OurTeam from './pages/about/OurTeam';
import YOCILABAcademy from './pages/programs/YOCILABAcademy';
import YociLabHub from './pages/YociLabHub';
import SignatureEvents from './pages/SignatureEvents';
import Seed4Impact from './pages/Seed4Impact';
import Contact from './pages/Contact';
import ImpactStoryDetail from './components/ImpactStoryDetail';
import ImpactStoriesPage from './pages/ImpactStoriesPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about/who-are-we" element={<WhoAreWe />} />
            <Route path="/about/why-it-matters" element={<WhyItMatters />} />
            <Route path="/about/our-team" element={<OurTeam />} />
            <Route path="/programs/yocilab-academy" element={<YOCILABAcademy />} />
            <Route path="/programs/yocilab-hub" element={<YociLabHub />} />
            <Route path="/signature-events" element={<SignatureEvents />} />
            <Route path="/seed4impact" element={<Seed4Impact />} />
            <Route path="/impact-stories" element={<ImpactStoriesPage />} />
            <Route path="/impact-story/:id" element={<ImpactStoryDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
